import { setSession, UserData_model } from '@shared/library';
import axios from 'axios';
import React from 'react';
import { decodeToken } from 'react-jwt';
import { useLocation } from 'react-router-dom';
import config from '../../../config';
import importer from '../../../helpers/importer';
import './SplashScreen.scss';
//CONTEXTS
import { CntxConfig } from '../../WebGest';


const SplashScreen = () => {
    //CONTEXTS USE
    const cntxConfig = React.useContext(CntxConfig)!;

    //STATIC DATA
    const location = useLocation();

    //METHODS
    const isLoggedInAPI = () => {
        axios.get<{ token: string; }>(`${config.api.internal}/Auth/SessionValid`, { withCredentials: true })
            .then(res => {
                const { token } = res.data;
                const userData = decodeToken<UserData_model>(token);

                if (userData) {
                    setSession(cntxConfig, { userData, support: localStorage.getItem('support') === '1' });
                }
                else {
                    setTimeout(isLoggedInAPI, 1000);
                }
            })
            .catch(error => {
                if (error?.code === 'ERR_NETWORK') {
                    setTimeout(isLoggedInAPI, 1000);
                }
                else {
                    cntxConfig?.set?.(undefined);
                }
            });
    };

    //STATES CHANGE
    React.useEffect(isLoggedInAPI, [cntxConfig, location]);

    return <div id="SplashScreen"><img alt="Loading" src={importer.animated.require('loading.gif')} /></div>;
};
export default React.memo(SplashScreen);